const attributesObj = {
  0: '校招',
  1: '社招',
  2: '实习生',
  3: '兼职'
}

const salaryType = {
  0: '',
  1: '13薪',
  2: '14薪',
  3: '15薪',
  4: '16薪',
  5: '17薪'
}

export {
  attributesObj,
  salaryType
}

